export default {
  getAuthenticationToken () {
    let authData = JSON.parse(localStorage.getItem('simple.result'))
    if (!authData) return null
    return authData.accessToken
  },

  getTenantId () {
    let authData = JSON.parse(localStorage.getItem('simple.result'))
    if (!authData) return null
    return authData.tenantId
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js